<template>
  <div>
    <div class="about">
      <div class="photo-content2" v-for="(item, index) in store.service" :key="index">
        <img :src='item.img'>
        <div class="mask"></div>
        <router-link :to='"/training-service-detail/"+index'></router-link>
        <p>
          <span>{{item.title}}</span>
          <span v-if="item.subTitle">{{item.subTitle}}</span>
          <span v-if="item.time">{{item.time}}</span>
          <span v-if="item.number">{{item.number}}</span>
        </p>
      </div>
      <div class="photo-content2">
        <img src="@/assets/img/case/cont.jpg">
        <div class="mask"></div>
        <router-link to="/meeting"></router-link>
        <p><span>更多案例,请联系我们...</span></p>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Footer from '@/components/Footer'
export default {
  name: 'TrainingService',
  components: {
    Footer
  },
  data() {
    return {
      store: this.$store.state
    };
  }
}
</script>
<style lang="less" scoped>
@media (min-width: 997px) {
  .about {
    margin-top: 80px;
    overflow: hidden;
    .photo-content2 {
      width: 25%;
      float: left;
      .mask {
        display: none;
      }
      a {
        opacity: 0;
      }
      p {
        display: none;
      }
    }
    .photo-content2:hover {
      .mask {
        display: block;
      }
      p {
        display: block;
      }
    }
  }
}
@media (max-width: 997px) {
  .about {
    margin-top: 60px;
  }
}

.photo-content2 {
  position: relative;
  font-size: 0;
  img {
    width: 100%;
  }
  .mask {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    background: #000;
    opacity: 0.5;
  }
  a {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 9;
    cursor: pointer;
  }
  p {
    position: absolute;
    text-align: center;
    font-size: 24px;
    color: #fff;
    width: 100%;
    top: 30%;
    span {
      display: block;
      text-align: center;
      font-size: 16px;
    }
    span:first-child {
      font-size: 24px;
    }
  }
}
</style>
